<template>
  <div class="flex items-center">
    <ElTooltip
      :content="error"
      placement="top"
      class="mr-sm"
    >
      <ExclamationIcon
        aria-hidden="false"
        :aria-invalid="error"
        class='text-white bg-envelopeStatus-cancelled rounded-full h-base w-base p-xs'
      />
    </ElTooltip>

    {{ value }}
  </div>
</template>

<script>
import { ExclamationIcon } from '@/components/icons/fontIcons';

export default {
  name: 'ErrorTableCell',
  components: {
    ExclamationIcon,
  },
  props: {
    value: {
      required: true,
      type: String,
    },
    error: {
      required: true,
      type: String,
    },
  },
};
</script>

<style scoped>

</style>
